'use client'

import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { NewsletterSubscribeAd } from './NewsletterSubscribeAd'
import { NewsletterSubscribeDisclaimer } from './NewsletterSubscribeDisclaimer'
import { NewsletterSubscribeForm } from './NewsletterSubscribeForm'

export const NewsletterSubscribeRequestContent: FC = () => {
  return (
    <>
      <h1 className="mb-4 text-3xl/3xl font-medium tablet:text-center">
        <FormattedMessage id="newsletter.subscribe.headline" />
      </h1>
      <h2 className="mb-6 text-l font-normal text-dark-brand-medium tablet:text-center">
        <FormattedMessage id="newsletter.subscribe.message" />
      </h2>
      <div>
        <NewsletterSubscribeForm />
        <NewsletterSubscribeAd />
        <NewsletterSubscribeDisclaimer />
      </div>
    </>
  )
}
